import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Document, Page, Text, View, Image, StyleSheet, pdf, Font } from "@react-pdf/renderer";
import { AuthContext } from "../contexts/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import SearchResult from "../components/SearchResult";
import SearchBar from "../components/SearchBar";
import Filters from "../components/Filters";
import "../styles/SearchResultsPage.css";
import QRCode from "qrcode";
import PDFSidebar from "../components/PDFSidebar";
import { translateText } from "../components/translateText";
import MenuDropdown from "../components/menuDropdown";
import { validateCountyName, validateZipCode } from "../components/RegExs";
import { FontStyles } from "../components/FontStyle";
import { APIBaseLink } from "../components/APIBaseLink";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Returs the current Google Translate language code active on the page
const getSelectedLanguage = () => {
	const select = document.querySelector(".goog-te-combo");
	return select ? select.value : "en";
};

const styles = FontStyles();

const SearchResultsPage = () => {
	const location = useLocation();
	const { selectedResources, addSelectedResource, removeSelectedResource, searchPagination, updateSearchPagination } = useContext(AuthContext);
	const { zipCode, updateZipCode } = useContext(AuthContext);
	const { countyName, updateCountyName } = useContext(AuthContext); //gets local storage of countyName
	const [results, setResults] = useState([]);
	const [currentPage, setCurrentPage] = useState(searchPagination || 1);
	const [totalPages, setTotalPages] = useState(1);
	const [keywordQuery, setKeywordQuery] = useState("");
	const [ageBracket, setAgeBracket] = useState(""); // Filter defaults start here
	const [filters, setFilters] = useState([]);
	//const [filtersSelected, setFiltersSelected] = useState(false);
	const [sortByLocation, setSortByLocation] = useState(false);
	const [sliderValue, setSliderValue] = useState(0);
	const navigate = useNavigate();
	const { user } = useContext(AuthContext);
	const API_BASE_LINK = APIBaseLink();

	const handleSearch = (e, queryType = "keyword", queryValue = "") => {
		e.preventDefault();
		const queryParams = new URLSearchParams();
		if (keywordQuery) queryParams.append("searchTerm", keywordQuery);
		// queryParams.append('zipCode', zipCode);
		if (zipCode !== "") {
			//user entered zip Code, append Zip Code to search query
			queryParams.append("zipCode", zipCode);
		} else {
			//user entered county name, append county name to search query
			queryParams.append("countyName", countyName);
		}
		navigate(`/search-results?${queryParams.toString()}`);
	};

	const saveSearch = async () => {
		const queryParams = new URLSearchParams(location.search);
		try {
			const token = localStorage.getItem("token");
			const string = queryParams.toString();
			const userId = user.id;
			const response = await toast.promise(
				fetch(`${API_BASE_LINK}/user/saveSearch`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${token}`,
					},
					body: JSON.stringify({
						userId: userId,
						search: string,
					}),
				}),
				{
					pending: "Saving Search...",
					success: "Search Saved Successfully.",
					error: "Failed To Save Search",
				}
			);
			// toast.promise(response, {
			// 	pending: "Saving Search...",
			// 	success: "Search Saved Successfully.",
			// 	error: "Failed To Save Search"
			// })

			if (response.ok) {
				// toast.success("Search Saved Successfully.");
			} else {
				// toast.error("Failed to Save Search.");
			}
		} catch (error) {
			console.log(error);
			toast.error("Failed To Save Search");
		}
	};

	/*const applyFilters = () => {
    setFiltersSelected(true);
  }*/

	useEffect(() => {
		if (zipCode && !countyName) {
			//user entered zipcode, so use the zipcode for searching
			const queryParams = new URLSearchParams(location.search);
			queryParams.set("zipCode", zipCode);
			queryParams.delete("countyName");
			navigate(`/search-results?${queryParams.toString()}`, { replace: true });
			
		} else if (!zipCode && countyName) {
			//user entered county name, so use the county name for searching
			const queryParams = new URLSearchParams(location.search);
			queryParams.set("countyName", countyName);
			queryParams.delete("zipCode");
			navigate(`/search-results?${queryParams.toString()}`, { replace: true });
		}
	}, [zipCode, countyName, navigate, location.search]);

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const keyword = queryParams.get("keyword");
		const searchTerm = queryParams.get("searchTerm");

		let zipCodeTemp;
		let countyNameTemp;

		//remove zipcode or county name from params if issue
		if (zipCode) {
			queryParams.set("zipCode", zipCode);
			zipCodeTemp = queryParams.get("zipCode");
		} else if (countyName) {
			queryParams.set("countyName", countyName);
			countyNameTemp = queryParams.get("countyName");
		} else {
			return;
		}
		// const zipCode = queryParams.get("zipCode");
		// const countyName = queryParams.get("countyName");
		const locationQuery = queryParams.get("location");

		let combinedSearchTerm = [searchTerm, ageBracket, ...filters]
			.filter(Boolean) // Remove empty/null values
			.join(" "); // Join into a single string

		let filter_list = [ageBracket, ...filters]
			.filter(Boolean) // Remove empty/null values
			.join(" "); // Join into a single string

		let obj = {
			category: keyword,
			searchTerm: searchTerm || null,
			zipCode: zipCodeTemp,
			countyName: countyNameTemp,
			page: currentPage,
			sortLocation: sortByLocation,
			sliderValue: sliderValue,
			filter_list: filter_list,
		};
		console.log(obj);

		fetch(`${API_BASE_LINK}/resource/search`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(obj),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data && data.results) {
					// If filter or ageBraket, then search again without filter or ageBracket.
					// SetTotalPages to regular search
					// Mark filtered resources with a special tag for CSS
					// If filtered resuls are less than 10
					// SetResults [filtered, regular]
					setTotalPages(data.totalPages);
					setResults(data.results);
					localStorage.setItem("results", JSON.stringify(data.results));
				} else {
					setResults([]);
				}
			})
			.catch((error) => {
				console.error("Error fetching search results:", error);
				setResults([]);
			});
	}, [location.search, currentPage, sortByLocation, sliderValue, zipCode, countyName, ageBracket, filters]); // Add zipCode to dependencies

	// Function to handle selection
	const handleSelect = (result, isSelected) => {
		if (isSelected) {
			addSelectedResource(result); // Add resource to global selectedResources
		} else {
			removeSelectedResource(result._id); // Remove resource by its ID from global selectedResources
		}
		//console.log("Selected Resources:", selectedResources);
	};

	const generateCombinedPDF = async () => {
		if (selectedResources.length === 0) {
			console.error("No results selected for PDF generation.");
			return;
		}

		const language = getSelectedLanguage();

		const apiKey = process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY;

		const labelsToTranslate = {
			services: "Services",
			eligibility: "Eligibility Requirements",
			phone: "Phone",
			email: "Email",
			address: "Address",
			website: "Website",
			howToApply: "How to Apply",
		};

		const translatedLabels = {};
		for (const key in labelsToTranslate) {
			translatedLabels[key] = await translateText(labelsToTranslate[key], language, apiKey);
		}

		const translatedResults = await Promise.all(
			selectedResources.map(async (resource) => {
				return {
					...resource,
					Services: await translateText(resource.Services, language, apiKey),
					Eligibility_Requirement: await translateText(resource.Eligibility_Requirement, language, apiKey),
					How_To_Apply: await translateText(resource.How_To_Apply, language, apiKey),
				};
			})
		);

		const SearchResultPDF = ({ results }) => {
			var currentLanguage = getSelectedLanguage();
			//console.log("TESTING: Current Language: ", currentLanguage);
			var setStyle = styles.page;

			// Selects which style page to use based on the current language selected (default english)
			switch (currentLanguage) {
				case 'ar':          // Arabic
				case 'bal':         // Baluchi
			    case 'ms-Arab':     // Malay Jawi
			    case 'ps':          // Pashto
			    case 'pa-Arab':     // Punjabi Shahmukhi
			    case 'ug':          // Uyghur
			    case 'fa':          // Persian
			    case 'ur':          // Urdu
			    	setStyle = styles.arabicpage;
			    	break;
			      
			    case 'zh-CN':       // Simplified Chinese
			    case 'zh':
			    	setStyle = styles.scpage;
			        break;
			      
			    case 'yue':         // Cantonese
			    case 'zh-TW':       // Traditional Chinese
			        setStyle = styles.tcpage;
			        break;
			
			    case 'ja':          // Japanese
			        setStyle = styles.jppage;
			        break;
			      
			    case 'my':          // Myanmar Burmese
			    case 'shn':         // Shan
			        setStyle = styles.mypage;
			        break;
			
			    case 'iw':          // Hebrew
			    case 'yi':          // Yiddish
			        setStyle = styles.hepage;
			        break;
			      
			    case 'ko':          // Korean
			        setStyle = styles.kepage;
			        break;
			
			    case 'lo':          // Lao
			        setStyle = styles.laoPage;
			        break;
			
			    case 'th':          // Thai
			        setStyle = styles.thaiPage;
			        break;
			
			    case 'kn':          // Kannada
			    case 'tcy':         // Tulu
			        setStyle = styles.KNPage;
			        break;
			
			    case 'ka':          // Georgian
			        setStyle = styles.georgianPage;
			        break;
			
			    case 'ml':          // Malayalam
			        setStyle = styles.mlpage;
			        break;
			
			    case 'pa':          // Punjabi (non-Arabic)
			        setStyle = styles.punjabipage;
			        break;
			
			    case 'bo':          // Tibetan
			    case 'dzo':         // Dzongkha
			    case 'dz':
			        setStyle = styles.tibetanpage;
			        break;
			
			    case 'as':          // Assamese
			    case 'bn':          // Bengali
			        setStyle = styles.bengalipage;
			        break;
			
			    case 'dv':          // Dhivehi
			    case 'div':
			        setStyle = styles.dhivehipage;
			        break;
			
			    case 'gu':          // Gujarati
			        setStyle = styles.gujaratipage;
			        break;
			
			    case 'iu':          // Inuktut
			    case 'iku':
			        setStyle = styles.inuktutpage;
			        break;
			
			    case 'km':          // Khmer
			        setStyle = styles.khmerpage;
			        break;
			
			    case 'or':          // Odia Oriya
			        setStyle = styles.oriyapage;
			        break;
			
			    case 'sat':         // Santali Ol Chiki
			        setStyle = styles.santalipage;
			        break;
			      
			    case 'sd':          // Sindhi
			        setStyle = styles.arabicpage;
			        break;
			      
			    case 'si':          // Sinhala
			        setStyle = styles.sinhalapage;
			        break;
			
			    case 'ber':         // Tamazight
			        setStyle = styles.tamazightpage;
			        break;
			
			    case 'ta':          // Tamil
			        setStyle = styles.tamilpage;
			        break;
			
			    case 'te':          // Telugu
			        setStyle = styles.telugupage;
			        break;
			
			    case 'ti':          // Tigrinya
			        setStyle = styles.tigrinyapage;
			        break;
			
			    default:            // Sets to english by default
			        setStyle = styles.page;
			}

			return (
				<Document>
					<Page size="LETTER" style={setStyle}>
						{results.map((result, index) => (
							<View key={index} style={styles.resultContainer} wrap={false}>
								{/* Title in its own container */}
								<View style={styles.titleContainer}>
									<Text style={styles.title}>{result.Name}</Text>
								</View>
								{/* Content and QR Code in a row */}
								<View style={styles.contentRow}>
									<View style={styles.content}>
										<View style={styles.section}>
											<Text style={styles.label}>{translatedLabels.services}: </Text>
											<Text style={styles.text}>{result.Services}</Text>

											<Text style={styles.label}>{translatedLabels.eligibility}: </Text>
											<Text style={styles.text}>{result.Eligibility_Requirement}</Text>

											<Text style={styles.label}>{translatedLabels.phone}: </Text>
											<Text style={styles.text}>{result.Phone}</Text>

											<Text style={styles.label}>{translatedLabels.email}: </Text>
											<Text style={styles.text}>{result.Email}</Text>

											<Text style={styles.label}>{translatedLabels.address}: </Text>
											{result.Address.map((line, i) => (
												<Text key={i} style={styles.text}>
													{line}
												</Text>
											))}

											<Text style={styles.label}>{translatedLabels.website}: </Text>
											<Text style={styles.text}>{result.Website}</Text>

											<Text style={styles.label}>{translatedLabels.howToApply}: </Text>
											<Text style={styles.text}>{result.How_To_Apply}</Text>
										</View>
									</View>
									{/* QR Code container */}
									<View style={styles.qrCodeContainer}>
										<QRCodeImage website={result.Website} />
									</View>
								</View>
							</View>
						))}
					</Page>
				</Document>
			);
		};

		// Helper function to check if a field is valid (not "N/A", "NA", or empty string)
		const isValidField = (field) => {
			return typeof field === "string" && field.toLowerCase() !== "n/a" && field.toLowerCase() !== "na" && field.trim() !== "";
		};

		// Function to find URLs in text and clean them
		const extractAndCleanURL = (text) => {
			if (!text) return null;

			// Enhanced regex to handle URLs with or without punctuation
			const urlPattern = /(?:\()?(https?:\/\/[^\s]+|www\.[^\s]+|[^\s]+\.(com|org|net|gov|edu|info))(?:\))?/gi;

			const match = text.match(urlPattern);
			if (match) {
				// Extract the first valid URL found and clean surrounding parentheses
				const cleanedMatch = match[0].replace(/[()]/g, "");
				return cleanedMatch.startsWith("http") ? cleanedMatch : `http://${cleanedMatch}`;
			}
			return null;
		};

		// This component generates the QR code for each result
		const QRCodeImage = ({ website }) => {
			const [qrCodeDataURL, setQrCodeDataURL] = useState("");

			useEffect(() => {
				// Validate and clean the URL before generating the QR code
				if (isValidField(website)) {
					const cleanedUrl = extractAndCleanURL(website);

					if (cleanedUrl) {
						QRCode.toDataURL(cleanedUrl)
							.then((url) => {
								setQrCodeDataURL(url);
							})
							.catch((err) => {
								console.error("Error generating QR code", err);
							});
					}
				}
			}, [website]);

			// Conditionally render the QR code or a message if there's no valid URL
			return qrCodeDataURL ? (
				<View style={styles.qrCodeContainer}>
					<Image source={{ uri: qrCodeDataURL }} style={styles.qrCodeImage} />
				</View>
			) : (
				<Text></Text>
			);
		};

		try {
			// Generate the single-page PDF for all selected results
			const pdfBlob = await pdf(<SearchResultPDF results={translatedResults} />).toBlob();
			const url = URL.createObjectURL(pdfBlob);
			window.open(url, "_blank");
		} catch (error) {
			console.error("Error generating combined PDF:", error);
		}
	};

	const handlePreviousPage = () => {
		if (currentPage > 1) {
			const newPage = currentPage - 1;
			setCurrentPage(newPage);
			updateSearchPagination(newPage); // Update pagination in context
		}
	};

	const handleNextPage = () => {
		if (currentPage < totalPages) {
			const newPage = currentPage + 1;
			setCurrentPage(newPage);
			updateSearchPagination(newPage); // Update pagination in context
		}
	};

	return (
		<div className="search-results-page">
			{/* Shows the menu for the site and uses zip code for menu search */}
			{/* <Menu/> */}
			<MenuDropdown />

			{/* Search Bar and Home Button at the Top of the Page */}
			<div className="search-header" style={{backgroundColor: '#FFF2D6', "padding-left": "20px", "padding-right": "20px", "margin-top": "20px"}} >
				<div className="back-button-container" >
					<button className="back-button" onClick={() => navigate("/")}>
						<FontAwesomeIcon icon={faHome} style={{ color: "#283618" }} />
					</button>
				</div>
				<div className="searchContainer">
					<h3 className="search-title">Search Services</h3>
					<form onSubmit={(e) => handleSearch(e, "keyword")}>
						<SearchBar placeholder="Search Services" value={keywordQuery} onChange={(e) => setKeywordQuery(e.target.value)} />
					</form>
				</div>
				<div>
					{user && (
						<button className="save-search-button" onClick={saveSearch}>
							Save Current Search
						</button>
					)}
				</div>
			</div>

			{/*Makes the filter and results show up side by side*/}
			<div className="content-wrapper">
				{/* The filters for searches*/}
				<div className="filters">
					<Filters
						zipCode={zipCode}
						updateZipCode={updateZipCode}
						countyName={countyName}
						updateCountyName={updateCountyName}
						ageBracket={ageBracket}
						setAgeBracket={setAgeBracket}
						filters={filters}
						setFilters={setFilters}
						sortByLocation={sortByLocation}
						setSortByLocation={setSortByLocation}
						sliderValue={sliderValue}
						setSliderValue={setSliderValue}
					/>
				</div>

				{/* The results of searches */}
				<div className="results">
					<h1>Search Results</h1>
					{results.length > 0 ? (
						filters ? (
							results.map((result, index) => (
								<div className="filtered-result">
									<SearchResult key={index} result={result} index={index} handleSelect={handleSelect} />
								</div>
							))
						) : (
							results.map((result, index) => <SearchResult key={index} result={result} index={index} handleSelect={handleSelect} />)
						)
					) : (
						<p>
							<em>More Resource Centers are being added to this zipcode soon. Please try another zipcode.</em>
						</p>
					)}

					{/* Includes print PDF, go to previous results, and go to next results */}
					<div className="pagination">
						<button className="navButtons" onClick={generateCombinedPDF}>
							Print PDF
						</button>
						<button className="navButtons" onClick={handlePreviousPage} disabled={currentPage === 1}>
							Previous
						</button>
						<span>
							Page {currentPage} of {totalPages}
						</span>
						<button className="navButtons" onClick={handleNextPage} disabled={currentPage === totalPages}>
							Next
						</button>
					</div>
				</div>

				{/* If no results added to "print pdf", the "Print PDF" button is disabled */}
				{selectedResources.length > 0 && (
					<div className="pdf-sidebar">
						<PDFSidebar />
					</div>
				)}
			</div>
		</div>
	);
};

export default SearchResultsPage;
